import { useMutation } from '@tanstack/react-query';
import { queryMutate } from '@/api/api';
export default function usePostDueNow() {
    return useMutation({
        mutationFn: async (params) => await queryMutate('/api/adventure/v2/checkout/calculation/', 'post', [params]),
    });
}
